import React from 'react';
import { Text } from '@carnica/ui-kit';
import { IconArrowsLeft, IconArrowsRight } from '@carnica/graphics';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Navigation = function Navigation(_ref) {
  var prevSlide = _ref.prevSlide,
    nextSlide = _ref.nextSlide,
    isStartSlider = _ref.isStartSlider,
    isEndSlider = _ref.isEndSlider,
    title = _ref.title,
    text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('component'),
    "data-t-id": "components-Navigation"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('block')
  }, /*#__PURE__*/React.createElement(Text, {
    className: cx('title')
  }, title), /*#__PURE__*/React.createElement(Text, {
    className: cx('text')
  }, text), /*#__PURE__*/React.createElement("div", {
    className: cx('navigation')
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434",
    className: cx('navigation-btn', {
      'navigation-btn--disable': isStartSlider
    }),
    onClick: prevSlide,
    type: "button"
  }, /*#__PURE__*/React.createElement(IconArrowsLeft, {
    className: cx('navigation-icon'),
    size: 24
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434",
    className: cx('navigation-btn', {
      'navigation-btn--disable': isEndSlider
    }),
    onClick: nextSlide,
    type: "button"
  }, /*#__PURE__*/React.createElement(IconArrowsRight, {
    className: cx('navigation-icon'),
    size: 24
  })))));
};